import { CountryEntity } from 'api/types/entity';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
  array,
  boolean,
} from 'libs/form';
import { Maybe } from 'types/maybe';

export interface OnboardingTaxResidencyFormTaxValue {
  taxNumberIsMissing?: boolean;
  taxNumber?: string;
  reasonForAbsence?: string;
  country: Maybe<CountryEntity>;
  fileIds?: string[];
}

export interface OnboardingTaxResidencyFormType {
  taxValues: OnboardingTaxResidencyFormTaxValue[];
}

export const MAX_FILES = 10;

export const getSchema = (
  enabledFiles: boolean = false
): ObjectSchema<OnboardingTaxResidencyFormType> =>
  object({
    taxValues: array()
      .of(
        object({
          taxNumberIsMissing: boolean().default(false),
          taxNumber: string().when('taxNumberIsMissing', {
            is: false,
            then: (schema) => schema.required().max(50),
          }),
          reasonForAbsence: string().when('taxNumberIsMissing', {
            is: true,
            then: (schema) => schema.required().max(2000),
          }),
          country: object({
            id: string().required(),
            name: string().required(),
          }).required(),
          fileIds: array()
            .of(string().required())
            .default([])
            .when('taxNumberIsMissing', {
              is: (v: boolean) => !v && enabledFiles,
              then: (schema) => schema.required().min(1).max(MAX_FILES),
            }),
        }).required()
      )
      .required(),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<OnboardingTaxResidencyFormType>();

export type FormErrors = FormErrorsBase<OnboardingTaxResidencyFormType>;
